import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import './History.css';

const DATA = [
  { year: `1975`, date: <FormattedMessage id="History.1975_date"/>, description: <FormattedMessage id="History.1975_description"/> },
  { year: `1976`, date: <FormattedMessage id="History.1976_date"/>, description: <FormattedMessage id="History.1976_description"/> },
  { year: `1982`, date: <FormattedMessage id="History.1982_date"/>, description: <FormattedMessage id="History.1982_description"/> },
  { year: `1997`, date: <FormattedMessage id="History.1997_date"/>, description: <FormattedMessage id="History.1997_description"/> },
  { year: `2000`, date: <FormattedMessage id="History.2000_date"/>, description: <FormattedMessage id="History.2000_description"/> },
  { year: `2013`, date: <FormattedMessage id="History.2013_date"/>, description: <FormattedMessage id="History.2013_description"/> },
];

export default class History extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  render() {
    return (
      <div className={classnames('History', this.props.className)}>
        <div className="History__content">
          <h2 className="History__title">
            <FormattedMessage id="History.title"/>
          </h2>
          <div className="History__items">
            {
              DATA.map(({ year, date, description }, idx) => (
                <div
                  key={idx}
                  className={classnames('History__item', {
                    'History__item--first': idx === 0
                  })}>
                  <div className="History__yearContainer">
                    <div className="History__year">
                      {year}
                    </div>
                    <div className="History__line"/>
                    <div className="History__circleWrapper">
                      <div className="History__circleLine"/>
                      <div className="History__circle"/>
                    </div>
                  </div>
                  <div className="History__labels">
                    <div className="History__date">
                      {date}
                    </div>
                    <div className="History__description">
                      {description}
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/History.js